import { DatePicker } from "@material-ui/pickers";
import {
  FormDataConsumer,
  ReferenceInput,
  required,
  SelectInput,
  useAuthenticated,
} from "react-admin";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { RouteComponentProps } from "react-router-dom";
import { ReportForm } from "../common/ReportForm";
import resourceNames from "../../../common/data/resourceNames";
import { useSearchFields } from "../../../common/hooks/useSearchFields";
import { DriverSelectionList } from "./DriverSelectionList";
import { reportFormats } from "../reportUtils";
import { Box, Divider } from "@material-ui/core";

interface Props extends RouteComponentProps {
  isDialog?: boolean;
}

export const SafetyReport = (props: Props) => {
  useAuthenticated();
  useSearchFields(undefined, ["name"], resourceNames.ADMIN_DRIVERS);

  return (
    <ReportForm
      reportName="safety-report"
      {...props}
      isDialog={props.isDialog}
      title="resources.reports.safety.name"
      submitMethod={(x) => x.reportSafetyreportPost}
    >
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateFrom"
        className={props.isDialog ? "safety-dashboard-wrapper-modal" : ""}
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateTo"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <ReferenceInput
        reference={resourceNames.ADMIN_COMPANIES}
        validate={required()}
        source="companyId"
      >
        <SelectInput />
      </ReferenceInput>
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          return (
            formData["companyId"] && (
              <FormDataConsumer>
                {({ formData, ...rest }) => {
                  return (
                    formData["companyId"] && (
                      <DriverSelectionList
                        source="driverIds"
                        filter={{ companyId: formData["companyId"] }}
                      />
                    )
                  );
                }}
              </FormDataConsumer>
            )
          );
        }}
      </FormDataConsumer>
      <Divider style={{ marginTop: "12px", marginBottom: "12px" }} />
      <Box sx={{ mt: "20px", minWidth: "100%" }}>
        <SelectInput
          variant="outlined"
          source="reportFormat"
          choices={reportFormats}
          validate={required()}
        />
      </Box>
    </ReportForm>
  );
};
